// extracted by mini-css-extract-plugin
export default {"manual-search-table":"manualSearchTable_manual-search-table__Vdy+S","flagged-column":"manualSearchTable_flagged-column__pgnk6"};